import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=c19e7ed2&"
import script from "./CustomerView.vue?vue&type=script&lang=ts&"
export * from "./CustomerView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports